import { render, staticRenderFns } from "./PortalUserActivity.vue?vue&type=template&id=4266704a&scoped=true&"
import script from "./PortalUserActivity.vue?vue&type=script&lang=js&"
export * from "./PortalUserActivity.vue?vue&type=script&lang=js&"
import style0 from "./PortalUserActivity.vue?vue&type=style&index=0&id=4266704a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266704a",
  null
  
)

export default component.exports